import React, { useState } from 'react';
import { LogIn, User, Lock, Eye, EyeOff } from 'lucide-react';
import APP_CONFIG from '../config';
import './Login.css';

const Login = ({ onLogin }) => {
  // Login state
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  // Password visibility
  const [showLoginPwd, setShowLoginPwd] = useState(false);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    if (!loginUsername.trim() || !loginPassword) {
      setLoginError('Please enter both username and password.');
      return;
    }
    setLoginLoading(true);
    const result = await onLogin(loginUsername.trim(), loginPassword);
    setLoginLoading(false);
    if (result && !result.ok) {
      setLoginError(result.error || 'Invalid credentials.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="grid-pattern"></div>
        <div className="gradient-overlay"></div>
      </div>

      <div className="login-card">
        {/* Header */}
        <div className="login-header">
          <div className="logo-container">
            <div className="logo-icon">
              {APP_CONFIG.LOGO_IMAGE ? (
                <img
                  src={`${process.env.PUBLIC_URL}/${APP_CONFIG.LOGO_IMAGE}`}
                  alt={APP_CONFIG.APP_NAME}
                  className="logo-image"
                />
              ) : (
                APP_CONFIG.LOGO_LETTER
              )}
            </div>
            <h1 className="logo-text">{APP_CONFIG.APP_NAME}</h1>
          </div>
          <p className="login-subtitle">{APP_CONFIG.APP_SUBTITLE}</p>
        </div>

        {/* ── LOGIN FORM ── */}
        <form onSubmit={handleLoginSubmit} className="login-form">
            <div className="input-group">
              <label htmlFor="login-username" className="input-label">
                <User size={16} /><span>Username</span>
              </label>
              <input
                id="login-username"
                type="text"
                value={loginUsername}
                onChange={(e) => setLoginUsername(e.target.value)}
                className="input-field"
                placeholder="Enter username"
                autoComplete="username"
                disabled={loginLoading}
              />
            </div>

            <div className="input-group">
              <label htmlFor="login-password" className="input-label">
                <Lock size={16} /><span>Password</span>
              </label>
              <div className="input-password-wrapper">
                <input
                  id="login-password"
                  type={showLoginPwd ? 'text' : 'password'}
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  className="input-field input-field--pwd"
                  placeholder="Enter password"
                  autoComplete="current-password"
                  disabled={loginLoading}
                />
                <button
                  type="button"
                  className="pwd-toggle"
                  onClick={() => setShowLoginPwd((v) => !v)}
                  tabIndex={-1}
                >
                  {showLoginPwd ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {loginError && (
              <div className="error-message animate-slide-in-up">{loginError}</div>
            )}

            <button type="submit" className="login-button" disabled={loginLoading}>
              {loginLoading ? (
                <span className="btn-spinner" />
              ) : (
                <LogIn size={18} />
              )}
              <span>{loginLoading ? 'Signing in…' : 'Sign In'}</span>
            </button>

        </form>
      </div>
    </div>
  );
};

export default Login;
